import { Stack } from "react-bootstrap";
import styles from "./action-panel.module.scss";
import { ActionCard } from "../action-card/action-card";
import { BookOpen, HelpCircle } from "react-feather";

export const ActionPanel = () => {
  return (
    <Stack direction="horizontal" gap={3} className={styles["action-panel"]}>
      <ActionCard
        IconComponent={BookOpen}
        title={"Instructions"}
        variant={"contained"}
      />
      <ActionCard
        IconComponent={HelpCircle}
        title={"Resources"}
        variant={"default"}
      />
    </Stack>
  );
};
